var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "13px",
    viewBox: "0 0 10 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#68C9D6",
    fill: "#68C9D6",
    fillRule: "nonzero",
    transform: "translate(4.929688, 6.500000) scale(-1, 1) translate(-4.929688, -6.500000) ",
    points: "2.359376 0.25 8.609376 6.5 2.359376 12.75 1.250001 11.6406 6.390626 6.5 1.25 1.35938"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftBlue);
export default __webpack_public_path__ + "static/media/chevron-left-blue.70664f3f30eebf9133fcfa29769a065f.svg";
export { ForwardRef as ReactComponent };